import {
  isValidInviteDomain,
  normalizeInviteDomain,
  normalizeInviteDomains,
} from "../../../../../smokepit/src/utils/inviteDomains";

export type DomainDraftMerge =
  | { status: "ok"; domains: string[] }
  | { status: "invalid"; error: string };

/**
 * Folds uncommitted text from the domains input into the committed chip list, so
 * typing a domain and pressing Save works without clicking Add first.
 * An invalid draft is an error rather than a silent drop.
 */
export function mergePendingDomainDraft(
  committed: string[],
  draft: string | null | undefined
): DomainDraftMerge {
  const domains = normalizeInviteDomains(committed);
  const candidate = normalizeInviteDomain(draft ?? "");
  if (!candidate) {
    return { status: "ok", domains };
  }
  if (!isValidInviteDomain(candidate)) {
    return {
      status: "invalid",
      error: `"${candidate}" is not a valid domain`,
    };
  }
  return {
    status: "ok",
    domains: domains.includes(candidate) ? domains : [...domains, candidate],
  };
}
